module.exports = __webpack_public_path__ + "fb686dd122ac2f98fa42963ddb2e5664.png";